import { LESSONS_TYPES } from '@yandex-int/k-common';
import { LessonsCount } from 'store/courses/typings';

export const getFormattedLessonsCount = (
    lessonsCounts: LessonsCount
): Record<'complete' | 'active' | 'drafts', number | undefined> => {
    const assignedCounts = lessonsCounts[LESSONS_TYPES.ASSIGNED] || 0;
    const activeCounts = lessonsCounts[LESSONS_TYPES.ACTIVE] || 0;
    const activeTabLessonsCount = assignedCounts + activeCounts;

    // не рисуем ничего, если пришел null или 0
    return {
        complete: lessonsCounts[LESSONS_TYPES.FINISHED] || undefined,
        active: activeTabLessonsCount || undefined,
        drafts: lessonsCounts[LESSONS_TYPES.UNASSIGNED] || undefined,
    };
};
